module.exports = __webpack_public_path__ + "img/event_bg.7a0bacc6.jpg";